<template> 
    <div>
        <!-- 点关闭或确认都是一个功能 -->
         <!-- 商品列表 -->
        <el-dialog title="编辑商品项号关系" :visible.sync="goodsNoShow" width="60%"  :close-on-click-modal="false" :before-close="goodsNoClose" >
            <el-table ref="goodsNoList" :data="goodsNoList" @selection-change="goodsNoChange" max-height="400px">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column property="gNo" label="序号" width="80"></el-table-column>
                <el-table-column property="codeTs" label="商品编号" width="200"></el-table-column>
                <el-table-column property="gName" label="商品名称" ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="sureGoodsNo()">确 定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>
<script>
export default {
    props: {
        goodsNoShow: {
            type: Boolean,
            default: false
        },
        goodsNoList:{// 商品列表
            type: Array,
            default: []
        }
    },
    data() {
        return {
            goodsNoVal:[],// 选中商品信息
        }
    },
    watch: {
    },
    mounted() { 
    },
    methods: { 
        // 选中商品时
        goodsNoChange(val){
            this.goodsNoVal = val
        },
        // 关闭弹窗,不赋值
        goodsNoClose(){
            this.$emit('goodsNoClose','')
        },
        // 确认选择商品序号
        sureGoodsNo(){
            var goodsNo = ''
            if(this.goodsNoVal.length){
                // 选中商品,用 , 连接
                goodsNo = this.goodsNoVal.map(item => {
                    return item.gNo + ','
                }).join("")
                // 删除最后一个 ,
                goodsNo = goodsNo.replace(/,(?=[^,]*$)/, '')
            }
            // 清空表格选中数据
            this.$refs.goodsNoList.clearSelection();
            this.$emit('goodsNoClose',goodsNo)
        },

    }
}
</script>
<style lang="css" scoped>
.messageIndex.el-message {
  z-index: 9999 !important;
}
::v-deep .el-table__body tr.current-row>td.el-table__cell{
    background-color: #FAFFBD !important;
}
.yellow .el-input__inner {
    background-color: #FAFFBD;
}
.width_100{
    width: 100%;
}
.margin_right_20{
    margin-right: 20px;
}
.el-button--mini {
    padding: 3px 4px;
    font-size: 12px;
}
.el-checkbox{
    white-space: normal;
    display: flex;
    align-self: flex-start;
    margin-top: 10px;
}
.flex_sb{
    display: flex;
    justify-content: space-between;
}
</style>